        import styled from 'styled-components';

        const BenefitsStyle = styled.section`
        margin-top: 56px;
        width: 100%;

        .experience__desc{
        p{
        color: #4F4F4F;
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 175%;
        @media only screen and (max-width: 992px){
        font-size: 15.5px;
        }

        @media only screen and (max-width: 768px){
        font-size: 14px;
        }

        @media only screen and (max-width: 576px){
        font-size: 12px;
        }
        }
        }
        .experience__content{
        margin-top: 67px;
        }
        .experience__content__img{
        margin-bottom: 0;
        }
        .experience__content__text{
        align-self: center;
        margin-bottom: 0;
        p{
        color: #333;
        font-family: Noto Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 175%; /* 56px */
        margin-bottom: 24px;
        @media only screen and (max-width: 992px){
        font-size: 24px;
        margin-top: 0px;
        }

        @media only screen and (max-width: 768px){
        font-size: 18px;
        }

        @media only screen and (max-width: 576px){
        margin-top: 16px;
        font-size: 16px;
        }
        }
        li{
        color: #333;
        font-family: Noto Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 175%; /* 35px */
        margin-bottom: 10px;
        margin-left: 30px;

        @media only screen and (max-width: 992px){
        font-size: 16px;
        }

        @media only screen and (max-width: 768px){
        font-size: 14px;
        }

        @media only screen and (max-width: 576px){
        font-size: 12px;
        }

        }
        }

        `;

        export default BenefitsStyle;
